(function ($) {
    
    const chatbubble1 = document.querySelector('.chatbubble-main');
//    const chatbubble2 = document.querySelector('#chatbubble-two');
    window.addEventListener('mousemove', (evt) => {
        const x = -(window.innerWidth / 2 - evt.pageX) / 80;
        const y = -(window.innerHeight / 2 - evt.pageY) / 80;
//        const x1 = -(window.innerWidth / 2 - evt.pageX) / 480;
//        const y1 = -(window.innerHeight / 2 - evt.pageY) / 480;
        chatbubble1.style.transform = `translateY(${y}px) translateX(${x}px)`;
//        chatbubble2.style.transform = `translateY(${y1}px) translateX(${x1}px)`;
    });  
})(jQuery);